<app-shared-alert-message></app-shared-alert-message>
<!-- Page content -->
<div class="page-content">
    <!-- Main content -->
    <div class="content-wrapper">
        <!-- Inner content -->
        <div class="content-inner">
            <router-outlet></router-outlet>
        </div>
        <!-- / Inner content -->
    </div>
    <!-- / Main content -->
</div>
<!-- / Page content -->
